export default "__VITE_ASSET__DgsExWiO__"